import React from 'react';
import HistoryGromming from '../components/HistoryGromming';
 

function GroomingHistory() {
 
    return (
      <div>
        <HistoryGromming  />

       
      </div>
    );
}

export default GroomingHistory;
